import { select } from "@fruugo/utilities";
import { fadeIn, fadeOut } from "../animations";

export const backdropClass = ".backdrop";

export function showBackdrop() {
  let backdrop = select(backdropClass) as HTMLElement;

  if (!backdrop) {
    document.body.appendChild(<Backdrop />);

    backdrop = select(backdropClass) as HTMLElement;
  }

  fadeIn(backdrop);
}

export function hideBackdrop() {
  const backdrop = select(backdropClass);
  backdrop && fadeOut(backdrop);
}

export const Backdrop = () => {
  return <div class={backdropClass.replace(".", "")}></div>;
};
